import React, { lazy } from 'react'
import { Route } from 'react-router'
import { LoggedInRoute } from '@/router/LoggedInRoute'
import { SubRouter } from '@/router/SubRouter'
import { SafetyActionRouter } from './actions/_router'
import { SafetyChangeRouter } from './changes/_router'
import { SafetyErpRouter } from './erp/_router'
import { SafetyExternalRouter } from './external/_router'
import { SafetyHazardRouter } from './hazards/_router'
import { SafetyInvestigationRouter } from './investigations/_router'
import { SafetyMeetingRouter } from './meetings/_router'
import { SafetyOccurrenceRouter } from './occurrences/_router'
import { SafetyPerformanceRouter } from './performance/_router'
import { SafetyPublicationRouter } from './publications/_router'

const Index = lazy(() => import('./Index'))
const DashboardIndex = lazy(() => import('./dashboard/Index'))
const ConfigIndex = lazy(() => import('./config/Index'))
const InboxIndex = lazy(() => import('./inbox/Index'))
const EccairsIndex = lazy(() => import('./eccairs/Index'))
const ErgIndex = lazy(() => import('./erg/Index'))

const guarded = (
  menuItem: `role--${string}`,
  element: React.ReactNode,
  ignoreSuperadmin?: boolean,
) => (
  <LoggedInRoute roles={[menuItem]} ignoreSuperadmin={ignoreSuperadmin}>
    {element}
  </LoggedInRoute>
)

export const SafetyRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--safety']}>
    <Route index element={<Index />} />
    <Route path='dashboard' element={guarded('role--safety--dashboard', <DashboardIndex />)} />

    {/* `report` est monté au niveau racine de _router.tsx (ouvert à tout utilisateur connecté) :
        il n'a rien à faire ici, où role--safety est exigé. */}
    <Route path='inbox' element={guarded('role--safety--inbox', <InboxIndex />)} />
    <Route path='occurrences/*' element={<SafetyOccurrenceRouter />} />
    <Route path='investigations/*' element={<SafetyInvestigationRouter />} />
    <Route path='hazards/*' element={<SafetyHazardRouter />} />
    <Route path='actions/*' element={<SafetyActionRouter />} />
    <Route path='changes/*' element={<SafetyChangeRouter />} />
    <Route path='performance/*' element={<SafetyPerformanceRouter />} />
    <Route path='meetings/*' element={<SafetyMeetingRouter />} />
    <Route path='publications/*' element={<SafetyPublicationRouter />} />
    <Route path='external/*' element={<SafetyExternalRouter />} />
    <Route path='erp/*' element={<SafetyErpRouter />} />
    <Route path='eccairs' element={guarded('role--safety--eccairs', <EccairsIndex />)} />
    {/*	Le superadmin n'est pas une personne désignée au sens de l'art. 6(1) : seuls SM et ERG ouvrent les revues. */}
    <Route path='erg' element={guarded('role--safety--erg', <ErgIndex />, true)} />

    <Route path='config/*' element={guarded('role--safety--config', <ConfigIndex />)} />
  </SubRouter>
))
